import React, { Context, createContext, useContext, useState } from "react"

export type AuthModalType =
  | "login"
  | "register"
  | "confirm-code"
  | "forgot-password"

export type InfoModalConfig = {
  title: string
  description: string
}

type GlobalModalsContextType = {
  visibleAuthModal: AuthModalType | undefined
  setVisibleAuthModal: (visibleAuthModal: AuthModalType | undefined) => void
  infoModalConfig: InfoModalConfig | undefined
  setInfoModalConfig: (config: InfoModalConfig | undefined) => void
}

const defaultContext: GlobalModalsContextType = {
  visibleAuthModal: undefined,
  setVisibleAuthModal: () => {},
  infoModalConfig: undefined,
  setInfoModalConfig: () => {},
}

export const GlobalModalsContext = createContext(defaultContext)

type Props = {
  children: React.ReactNode
}

export const GlobalModalsProvider = ({ children }: Props) => {
  const [visibleAuthModal, setVisibleAuthModal] = useState<AuthModalType>()
  const [infoModalConfig, setInfoModalConfig] = useState<InfoModalConfig>()
  const context = {
    visibleAuthModal,
    setVisibleAuthModal,
    infoModalConfig,
    setInfoModalConfig,
  }

  return (
    <GlobalModalsContext.Provider value={context}>
      {children}
    </GlobalModalsContext.Provider>
  )
}

export const useGlobalModals = () => {
  return useContext<GlobalModalsContextType>(
    GlobalModalsContext as Context<GlobalModalsContextType>
  )
}
